"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.number.constructor");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _elementUi = require("element-ui");

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _customer = require("./customer.constants");

var _permission = require("@/mixins/permission/permission");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomerComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(CustomerComponent, _Mixins);

  var _super = _createSuper(CustomerComponent);

  function CustomerComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, CustomerComponent);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.timeZoneList = _customer.DEFAULT_TIMEZONES;
    _this.permissionList = _customer.DEFAULT_PERMISSIONS;
    _this.zoneList = _customer.DEFAULT_ZONES;
    _this.customers = [];
    _this.currentPage = 1;
    _this.pageSize = 10;
    _this.totalData = 1; // private projectCodeId: string = '';
    // private numberOfZone: number = 1;
    // private dataSet: any = null;
    // private locations: object = { 'latitude': '22.28552', 'longitude': '114.15769' };
    // private projectCodes: any[] = [];
    // private locationList: any[] = [];

    _this.registeredCompIds = [];
    _this.companies = [];
    _this.selectedCompany = null; // private isShowZoneModal: boolean = false;

    _this.isShowCustomerModal = false;
    _this.isInsert = true;
    _this.DEFAULT_FORM_DATA = {
      code: null,
      company: null,
      data: {
        country: 'Hong Kong',
        latlng: '22.383591,114.121658',
        timezone: 8,
        updateUserData: false,
        checkReadyToShip: false,
        orderAssignmentReadyToShip: false,
        planIdFormat: process.env.VUE_APP_PLANIDCODE,
        permission: ['lastMileV2', 'data']
      },
      default5: false,
      default30: 'default'
    };
    _this.formData = {};
    _this.searchValue = '';
    return _this;
  }

  (0, _createClass2.default)(CustomerComponent, [{
    key: "onChangeSearchValue",
    value: function onChangeSearchValue() {
      this.currentPage = 1;
    }
  }, {
    key: "beforeCreate",
    value: function () {
      var _beforeCreate = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.requestAuth) {
                  this.requestAuth = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
                }

                if (!this.request) {
                  this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
                }

                if (!this.requestFile) {
                  this.requestFile = new _request.Request('multipart/form-data', process.env.VUE_APP_SECRET_KEY_HASH);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function beforeCreate() {
        return _beforeCreate.apply(this, arguments);
      }

      return beforeCreate;
    }()
  }, {
    key: "created",
    value: function created() {
      var _this2 = this;

      this.loading = true;
      this.requestParameters[process.env.VUE_APP_CUSTOMER_KEY] = this.$userInformation.customerKey || '';
      this.getAllCompany();
      this.getAllCustomer().then(function (data) {
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.loading = false;
    }
  }, {
    key: "indexMethod",
    value: function indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    }
  }, {
    key: "onPagination",
    value: function onPagination(currentPage) {
      this.currentPage = currentPage;
    }
  }, {
    key: "onSizeChange",
    value: function onSizeChange(pageSize) {
      this.pageSize = pageSize;
    }
  }, {
    key: "generateKey",
    value: function () {
      var _generateKey = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var companyId, userId, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                companyId = process.env.NODE_ENV === 'development' ? 34 : 118;
                userId = process.env.NODE_ENV === 'development' ? 198 : 1989;
                _context2.next = 4;
                return this.requestAuth.post('LEGACY_TOOL', 'encode-key', {}, {
                  companyId: companyId,
                  userId: userId
                });

              case 4:
                res = _context2.sent;

                if (res['data']) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", false);

              case 7:
                return _context2.abrupt("return", res['data']);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function generateKey() {
        return _generateKey.apply(this, arguments);
      }

      return generateKey;
    }()
  }, {
    key: "getAllCompany",
    value: function () {
      var _getAllCompany = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var key;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.generateKey();

              case 2:
                key = _context3.sent;
                this.requestAuth = new _request.Request('application/json', key);
                return _context3.abrupt("return", this.requestAuth.get('LEGACY_CORE', 'companies', {
                  limit: 1000,
                  test: true
                }).then(function (data) {
                  if (!data['data']) {
                    return Promise.reject('');
                  }

                  _this3.companies = data['data'];
                  return true;
                }).catch(function () {
                  _this3.logger.error('companies is empty');

                  return false;
                }));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllCompany() {
        return _getAllCompany.apply(this, arguments);
      }

      return getAllCompany;
    }()
  }, {
    key: "handleSelectCompany",
    value: function handleSelectCompany(_companyId) {
      var company = this.companies.find(function (comp) {
        return comp.RecId === _companyId;
      });
      this.formData['code'] = "logflows-".concat(_companyId);
      this.formData['company'] = company.CompName;
    }
  }, {
    key: "getAllCustomer",
    value: function getAllCustomer() {
      var _this4 = this;

      return this.request.get('AI_CUSTOMER', '', _objectSpread(_objectSpread({}, this.requestParameters), {}, {
        limit: 300
      })).then(function (data) {
        if (!data['data']) {
          return Promise.reject('');
        }

        _this4.currentPage = 1;
        _this4.totalData = data['pagination']['totalData'] || 1;
        _this4.customers = data['data'].map(function (customer) {
          customer['default5'] = _this4.checkTrue(customer['default5']);
          return customer;
        });
        _this4.registeredCompIds = _this4.customers.map(function (customer) {
          return Number(customer['code'].split('logflows-')[1]);
        });
        return true;
      }).catch(function () {
        _this4.logger.error('customer is empty');

        return false;
      });
    }
  }, {
    key: "getCustomer",
    value: function getCustomer() {
      var _this5 = this;

      var customer = this.customers.filter(function (data) {
        return !_this5.searchValue || data.company.toLowerCase().includes(_this5.searchValue.toLowerCase());
      });
      return customer.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    }
  }, {
    key: "addCustomer",
    value: function addCustomer() {
      var _this6 = this;

      var cleanData = this.cleanFormData(this.formData);
      this.logger.info("form submitted: ".concat(JSON.stringify(cleanData)));
      this.request.post('AI_CUSTOMER', '', this.requestParameters, cleanData).then(function (data) {
        if (data.failed) {
          return Promise.reject(data.message || '');
        }

        _this6.formData['code'] = null;
        _this6.formData['company'] = null;
        _this6.formData['data']['country'] = null;
        _this6.formData['data']['latlng'] = null;
        _this6.formData['data']['timezone'] = 8;
        _this6.formData['data']['updateUserData'] = false;
        _this6.formData['data']['checkReadyToShip'] = false;
        _this6.formData['data']['orderAssignmentReadyToShip'] = false;
        _this6.formData['data']['permission'] = [];
        _this6.formData['default5'] = false;
        _this6.formData['default30'] = 'default';
        _this6.searchValue = '';
        return _this6.getAllCustomer();
      }).then(function (data) {
        if (!data) {
          return Promise.reject('');
        }

        _this6.isShowCustomerModal = false;
        var message = {
          title: _this6.$i18n.t('notification.customer.insertSuccess'),
          duration: 5000
        };

        _elementUi.Notification.success(message);
      }).catch(function (error) {
        var message = {
          title: _this6.helper.toString(error),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      });
    }
  }, {
    key: "updateCustomer",
    value: function updateCustomer() {
      var _this7 = this;

      var customerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (customerId) {
        var cleanData = this.cleanFormData(this.formData);
        this.logger.info("form submitted: ".concat(JSON.stringify(cleanData)));
        this.request.put('AI_CUSTOMER', customerId, this.requestParameters, cleanData).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          _this7.searchValue = '';
          return _this7.getAllCustomer();
        }).then(function (data) {
          if (!data) {
            return Promise.reject('');
          }

          _this7.handleHideCustomer();

          var message = {
            title: _this7.$i18n.t('notification.customer.updateSuccess'),
            duration: 5000
          };

          _elementUi.Notification.success(message);
        }).catch(function (error) {
          var message = {
            title: _this7.helper.toString(error),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        });
      }
    }
  }, {
    key: "deleteCustomer",
    value: function deleteCustomer() {
      var _this8 = this;

      var customerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (customerId) {
        this.request.delete('AI_CUSTOMER', customerId, this.requestParameters).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          _this8.searchValue = '';
          return _this8.getAllCustomer();
        }).then(function (data) {
          if (!data) {
            return Promise.reject('');
          }

          var message = {
            title: _this8.$i18n.t('notification.customer.deleteSuccess'),
            duration: 5000
          };

          _elementUi.Notification.success(message);
        }).catch(function (error) {
          var message = {
            title: _this8.helper.toString(error),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        });
      }
    }
  }, {
    key: "cleanFormData",
    value: function cleanFormData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (!data['data']['checkReadyToShip']) {
        data['data']['orderAssignmentReadyToShip'] = false;
      }

      var finalData = {
        'code': data['code'],
        'key': data['key'],
        'company': data['company'],
        'data': data['data'],
        'default5': data['default5'] ? data['default5'] : false,
        'default30': data['default30'] ? data['default30'] : 'default'
      };
      return this.helper.cleanDataRemoveNull(finalData);
    }
    /*onDataSetChanges(): void {
      const file: any = this.$refs.dataSet;
      if (typeof(file) !== 'undefined') {
        this.dataSet =  file.files[0];
      }
    }*/

    /*uploadZone(): void {
      const mapWorld: any = this.$refs.mapWorld;
      if (typeof(mapWorld) !== 'undefined' && this.dataSet && this.dataSet.constructor.name === 'File') {
        const formData = new FormData();
        const zoneList = [];
           for (let index = 0; index < this.numberOfZone; index++) {
          zoneList.push(this.helper.randomColor);
        }
           formData.append('dataSet', this.dataSet);
        formData.append('latitudeIndex', '1');
        formData.append('longitudeIndex', '2');
        formData.append('zones', this.helper.toString(zoneList));
           this.requestFile.put('AI_ROUTE_V2', 'zoning', {...this.requestParameters, [process.env.VUE_APP_CUSTOMER_KEY]: this.formData['key']}, formData)
          .then((data) => {
            if (data.failed) {
              return Promise.reject(data.message || '');
            }
               this.locationList = data['data'] || [];
            mapWorld.initAllPolygon(this.locationList);
          })
          .catch((error) => {
            const message: ElNotificationOptions = {
              title: this.helper.toString(error),
              duration: 5000
            } as ElNotificationOptions;
               Notification.error(message);
          });
      }
    }*/

    /*updateZone(customerId: string = ''): void {
      if (customerId && this.locationList && this.locationList.length >= 1) {
        const cleanData: object = this.cleanZoneData(this.locationList);
         this.logger.info(`form submitted: ${JSON.stringify(cleanData)}`);
         this.request.post('AI_ROUTE_V2', 'zoning', {...this.requestParameters, [process.env.VUE_APP_CUSTOMER_KEY]: this.formData['key']}, cleanData)
        .then((data) => {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }
             const message: ElNotificationOptions = {
            title: this.$i18n.t('notification.customer.updateSuccess'),
            duration: 5000
          } as ElNotificationOptions;
             Notification.success(message);
             this.handleHideZone();
        })
        .catch((error) => {
          const message: ElNotificationOptions = {
            title: this.helper.toString(error),
            duration: 5000
          } as ElNotificationOptions;
             Notification.error(message);
        });
      }
    }*/

    /*cleanZoneData(data: Array<any> = []): object {
      const finalData: object  = {
        'zones': data.map( (datavalue, indexvalue) => {
          datavalue['code'] = `ZONE${indexvalue + 1}`;
          datavalue['name'] = '';
             return datavalue;
        })
      };
         return this.helper.cleanDataRemoveNull(finalData);
    }*/

    /*handleHideZone() {
      this.formData = this.helper.cloneDeep(this.DEFAULT_FORM_DATA);
      this.numberOfZone = 1;
      this.dataSet = null;
      this.locationList = [];
         const file: any = this.$refs.dataSet;
      if (typeof(file) !== 'undefined') {
        file.value = null;
      }
         const mapWorld: any = this.$refs.mapWorld;
      if (typeof(mapWorld) !== 'undefined') {
        mapWorld.initAllPolygon(this.locationList);
      }
         this.locations = { 'latitude': '22.28552', 'longitude': '114.15769' };
         this.isShowZoneModal = false;
    }*/

    /*handleShowZone(customerData: object = {}) {
      this.formData = this.helper.cloneDeep(customerData);
      if (this.formData['data']['latlng']) {
          const latlng = this.formData['data']['latlng'].split(',');
          this.locations = {
            'latitude': (isNaN(latlng[0])) ? '22.28552' : latlng[0],
            'longitude': (isNaN(latlng[1])) ? '114.15769' : latlng[1],
          };
      }
         this.isShowZoneModal = true;
    }*/

  }, {
    key: "handleHideCustomer",
    value: function handleHideCustomer() {
      this.formData = this.helper.cloneDeep(this.DEFAULT_FORM_DATA);
      this.selectedCompany = null;
      this.isShowCustomerModal = false;
      this.isInsert = true;
    }
  }, {
    key: "handleShowCustomerInsert",
    value: function handleShowCustomerInsert() {
      this.formData = this.helper.cloneDeep(this.DEFAULT_FORM_DATA);
      this.selectedCompany = null;
      this.isShowCustomerModal = true;
      this.isInsert = true;
    }
  }, {
    key: "handleShowCustomer",
    value: function handleShowCustomer() {
      var customerData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.formData = this.helper.cloneDeep(customerData);
      this.selectedCompany = Number(this.formData['code'].split('logflows-')[1]);
      this.isShowCustomerModal = true;
      this.isInsert = false;
    }
  }, {
    key: "handleDeleteCustomer",
    value: function handleDeleteCustomer() {
      var _this9 = this;

      var customerData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.formData = this.helper.cloneDeep(customerData);

      _elementUi.MessageBox.confirm("".concat(this.$i18n.t('customer.deleteCustomerText'), " ").concat(this.formData['company']), 'Warning', {
        confirmButtonText: this.$i18n.t('general.delete'),
        cancelButtonText: this.$i18n.t('general.cancel'),
        type: 'warning',
        center: true
      }).then(function () {
        _this9.deleteCustomer(_this9.formData['_id']);
      }).catch(function () {
        _this9.formData = _this9.helper.cloneDeep(_this9.DEFAULT_FORM_DATA);
      });
    }
  }, {
    key: "checkTrue",
    value: function checkTrue(data) {
      return data && data !== '' && (data === 'True' || data === 'true' || data === true) ? true : false;
    }
  }]);
  return CustomerComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], CustomerComponent.prototype, "$lfToken", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('searchValue')], CustomerComponent.prototype, "onChangeSearchValue", null);
CustomerComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'CustomerComponent',
  components: {
    'el-tooltip': _elementUi.Tooltip,
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-pagination': _elementUi.Pagination,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-dialog': _elementUi.Dialog,
    'el-button': _elementUi.Button,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-input': _elementUi.Input,
    'el-input-number': _elementUi.InputNumber,
    'el-upload': _elementUi.Upload,
    'el-switch': _elementUi.Switch,
    'el-checkbox': _elementUi.Checkbox,
    'map-world': _mapWorld.default
  }
})], CustomerComponent);
var _default = CustomerComponent;
exports.default = _default;